<template>
  <div v-if="$auth.user().isAdmin || $auth.user().isMst" class="card mb-2 p-2">
    <div class="row">
      <div class="col text-center">
        <h3 style="padding-right: 40px">Административная панель</h3>
        <span class="p-0 m-0">
          <router-link to="/" v-b-tooltip.hover title="Назад" class="btn btn-outline p-1">
            <i class="fa fa-2x fa-arrow-left"></i>
          </router-link>
          <router-link to="/admin/projects" v-b-tooltip.hover title="Проекты" class="btn btn-outline p-1">
            <i class="fa fa-2x fa-calculator"></i>
          </router-link>
          <router-link to="/admin/users" v-b-tooltip.hover title="Пользователи" class="btn btn-outline p-1">
            <i class="fa fa-2x fa-users"></i>
          </router-link>
          <router-link
            to="/admin/keys"
            v-if="$auth.user().isAdmin || $auth.user().isMst"
            v-b-tooltip.hover
            title="Ключи"
            class="btn btn-outline p-1"
          >
            <i class="fa fa-2x fa-key"></i>
          </router-link>
          <router-link
            to="/admin/mailing"
            v-if="$auth.user().isAdmin || $auth.user().isMst"
            v-b-tooltip.hover
            title="Рассылка"
            class="btn btn-outline p-1"
          >
            <i class="fa fa-2x fa-envelope"></i>
          </router-link>
          <a href="#" v-if="$auth.user().isMst" v-b-modal.mst
            ><img style="margin-top: -3px" width="28" height="28" src="/mst.png"
          /></a>
        </span>
      </div>
    </div>
    <div class="row pt-5">
      <div class="col">
        <router-view></router-view>
      </div>
    </div>
    <b-modal id="mst" ref="mst" hide-footer size="xl" title="Панель управления MST">
      <mst></mst>
    </b-modal>
  </div>
</template>
<script>
import mst from "./mst/Index";
export default {
  components: {
    mst,
  },
  data() {
    return {
      test: null,
      errors: null,
    };
  },
  created() {
    if (!this.$auth.user().isAdmin && !this.$auth.user().isMst) {
      this.$router.push({ name: "home" });
    }
  },
  methods: {
    getTest() {
      this.test = null;
      this.errors = null;
      this.$http
        .get("molotok/test/test", {})
        .then((response) => {
          this.test = response.data;
        })
        .catch((e) => {
          this.errors = e.response.data;
        });
    },
  },
};
</script>
